import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

// 效果 24: 彩虹光晕
export const RainbowGlow: React.FC = () => {
  const frame = useCurrentFrame();
  const hue = interpolate(frame, [0, 120], [0, 360], {
    extrapolateRight: "clamp",
  });
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0a0a0a",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: `radial-gradient(circle, 
            hsla(${hue}, 100%, 50%, 0.8),
            hsla(${hue + 60}, 100%, 50%, 0.6),
            hsla(${hue + 120}, 100%, 50%, 0.4),
            transparent
          )`,
          filter: "blur(20px)",
        }}
      />
    </AbsoluteFill>
  );
};

// 效果 25: 霓虹边框
export const NeonBorder: React.FC = () => {
  const frame = useCurrentFrame();
  const hue = interpolate(frame, [0, 120], [0, 360], {
    extrapolateRight: "clamp",
  });
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#000",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: 400,
          height: 400,
          border: `5px solid hsl(${hue}, 100%, 50%)`,
          boxShadow: `
            0 0 10px hsl(${hue}, 100%, 50%),
            0 0 20px hsl(${hue}, 100%, 50%),
            0 0 40px hsl(${hue}, 100%, 50%),
            0 0 80px hsl(${hue}, 100%, 50%)
          `,
        }}
      />
    </AbsoluteFill>
  );
};

// 效果 26: 发光文字
export const GlowingText: React.FC = () => {
  const frame = useCurrentFrame();
  const intensity = interpolate(
    Math.sin(frame * 0.1),
    [-1, 1],
    [0.5, 1]
  );
  const hue = interpolate(frame, [0, 120], [0, 360], {
    extrapolateRight: "clamp",
  });
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0f0f23",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 100,
          fontWeight: "bold",
          color: `hsl(${hue}, 100%, 50%)`,
          textShadow: `
            0 0 10px hsl(${hue}, 100%, 50%),
            0 0 20px hsl(${hue}, 100%, 50%),
            0 0 40px hsl(${hue}, 100%, 50%),
            0 0 80px hsl(${hue}, 100%, 50%)
          `,
          opacity: intensity,
        }}
      >
        GLOW
      </div>
    </AbsoluteFill>
  );
};

// 效果 27: 渐变文字
export const GradientText: React.FC = () => {
  const frame = useCurrentFrame();
  const position = interpolate(frame, [0, 120], [0, 100], {
    extrapolateRight: "clamp",
  });
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#1a1a2e",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 120,
          fontWeight: "bold",
          background: `linear-gradient(90deg, 
            #ff6b6b 0%, 
            #4ecdc4 50%, 
            #ffe66d 100%
          )`,
          backgroundSize: "200% 100%",
          backgroundPosition: `${position}% 0`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        GRADIENT
      </div>
    </AbsoluteFill>
  );
};
